import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-science-lab',
  templateUrl: './science-lab.component.html',
  styleUrls: ['./science-lab.component.scss']
})
export class ScienceLabComponent implements OnInit {
  activeTab = 'physics';
  activeLightboxImage: string | null = null;

  physicsImages = [
    '/assets/img/facilities/imgi_437_physics_lab_img1-1200x800.jpg',
    '/assets/img/facilities/imgi_428_physics_lab_img2-1200x800.jpg',
    '/assets/img/facilities/imgi_431_physics_lab_img3-1200x800.jpg',
    '/assets/img/facilities/imgi_422_physics_lab_img4-1200x800.jpg',
    '/assets/img/facilities/imgi_416_physics_lab_img6-1200x800.jpg',
    '/assets/img/facilities/imgi_413_physics_lab_img8-1200x800.jpg'
  ];

  chemistryImages = [
    '/assets/img/facilities/imgi_209_chemistry_lab_img1-1200x800.jpg',
    '/assets/img/facilities/imgi_206_chemistry_lab_img2-1200x800.jpg',
    '/assets/img/facilities/imgi_203_chemistry_lab_img3-1200x800.jpg',
    '/assets/img/facilities/imgi_200_chemistry_lab_img4-1200x800.jpg',
    '/assets/img/facilities/imgi_197_chemistry_lab_img5-1200x800.jpg',
    '/assets/img/facilities/imgi_194_chemistry_lab_img6-1200x800.jpg'
  ];

  homeScienceImages = [
    '/assets/img/facilities/imgi_345_home_science_lab1-1067x800.jpg',
    '/assets/img/facilities/imgi_342_home_science_lab2-1067x800.jpg',
    '/assets/img/facilities/imgi_362_home_science_lab3-1400x749.jpg',
    '/assets/img/facilities/imgi_339_home_science_lab4-1200x800.jpg',
    '/assets/img/facilities/imgi_359_home_science_lab5-1200x800.jpg'
  ];

  constructor() { }

  ngOnInit(): void { }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  openLightbox(src: string): void {
    this.activeLightboxImage = src;
  }

  closeLightbox(): void {
    this.activeLightboxImage = null;
  }
}

